module.exports = __webpack_public_path__ + "img/recharge_demo_v3.1fe17fbb.png";